module.exports = __webpack_public_path__ + "media/images/icon_list/delete_indent-061c1e0a646d5d701b3e69a4ff8eccd4.svg";